import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enNavbarMenus from './locales/en/navbarMenus.json';
import enNavigation from './locales/en/navigation.json';
import enOrganizationSettings from './locales/en/organizationSettings.json';
import enAdminPages from './locales/en/adminPages.json';
import enProfile from './locales/en/profile.json';
import enJobPortal from './locales/en/jobPortal.json';
import enAuth from './locales/en/auth.json';
import enHome from './locales/en/home.json';
import enAssessments from './locales/en/assessments.json';

import idCommon from './locales/id/common.json';
import idNavbarMenus from './locales/id/navbarMenus.json';
import idNavigation from './locales/id/navigation.json';
import idOrganizationSettings from './locales/id/organizationSettings.json';
import idAdminPages from './locales/id/adminPages.json';
import idProfile from './locales/id/profile.json';
import idJobPortal from './locales/id/jobPortal.json';
import idAuth from './locales/id/auth.json';
import idHome from './locales/id/home.json';
import idAssessments from './locales/id/assessments.json';

import siCommon from './locales/si/common.json';
import siNavbarMenus from './locales/si/navbarMenus.json';
import siNavigation from './locales/si/navigation.json';
import siOrganizationSettings from './locales/si/organizationSettings.json';
import siAdminPages from './locales/si/adminPages.json';
import siProfile from './locales/si/profile.json';
import siJobPortal from './locales/si/jobPortal.json';
import siAuth from './locales/si/auth.json';
import siHome from './locales/si/home.json';
import siAssessments from './locales/si/assessments.json';

import taCommon from './locales/ta/common.json';
import taNavbarMenus from './locales/ta/navbarMenus.json';
import taNavigation from './locales/ta/navigation.json';
import taOrganizationSettings from './locales/ta/organizationSettings.json';
import taAdminPages from './locales/ta/adminPages.json';
import taProfile from './locales/ta/profile.json';
import taJobPortal from './locales/ta/jobPortal.json';
import taAuth from './locales/ta/auth.json';
import taHome from './locales/ta/home.json';
import taAssessments from './locales/ta/assessments.json';

import ruCommon from './locales/ru/common.json';
import ruNavbarMenus from './locales/ru/navbarMenus.json';
import ruNavigation from './locales/ru/navigation.json';
import ruOrganizationSettings from './locales/ru/organizationSettings.json';
import ruAdminPages from './locales/ru/adminPages.json';
import ruProfile from './locales/ru/profile.json';
import ruJobPortal from './locales/ru/jobPortal.json';
import ruAuth from './locales/ru/auth.json';
import ruHome from './locales/ru/home.json';
import ruAssessments from './locales/ru/assessments.json';

import { NS } from './constants/keys';
import {
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
  SupportedLocale,
} from './locale';

export { LOCALE_STORAGE_KEY, SUPPORTED_LOCALES, setAppLocale } from './locale';
export type { SupportedLocale } from './locale';

const storedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
const defaultLocale: SupportedLocale =
  storedLocale && (SUPPORTED_LOCALES as readonly string[]).includes(storedLocale)
    ? (storedLocale as SupportedLocale)
    : 'en';

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      [NS.common]: enCommon,
      [NS.organizationSettings]: enOrganizationSettings,
      [NS.navigation]: enNavigation,
      [NS.navbarMenus]: enNavbarMenus,
      [NS.profile]: enProfile,
      [NS.adminPages]: enAdminPages,
      [NS.jobPortal]: enJobPortal,
      [NS.auth]: enAuth,
      [NS.home]: enHome,
      [NS.assessments]: enAssessments,
    },
    id: {
      [NS.common]: idCommon,
      [NS.organizationSettings]: idOrganizationSettings,
      [NS.navigation]: idNavigation,
      [NS.navbarMenus]: idNavbarMenus,
      [NS.profile]: idProfile,
      [NS.adminPages]: idAdminPages,
      [NS.jobPortal]: idJobPortal,
      [NS.auth]: idAuth,
      [NS.home]: idHome,
      [NS.assessments]: idAssessments,
    },
    si: {
      [NS.common]: siCommon,
      [NS.organizationSettings]: siOrganizationSettings,
      [NS.navigation]: siNavigation,
      [NS.navbarMenus]: siNavbarMenus,
      [NS.profile]: siProfile,
      [NS.adminPages]: siAdminPages,
      [NS.jobPortal]: siJobPortal,
      [NS.auth]: siAuth,
      [NS.home]: siHome,
      [NS.assessments]: siAssessments,
    },
    ta: {
      [NS.common]: taCommon,
      [NS.organizationSettings]: taOrganizationSettings,
      [NS.navigation]: taNavigation,
      [NS.navbarMenus]: taNavbarMenus,
      [NS.profile]: taProfile,
      [NS.adminPages]: taAdminPages,
      [NS.jobPortal]: taJobPortal,
      [NS.auth]: taAuth,
      [NS.home]: taHome,
      [NS.assessments]: taAssessments,
    },
    ru: {
      [NS.common]: ruCommon,
      [NS.organizationSettings]: ruOrganizationSettings,
      [NS.navigation]: ruNavigation,
      [NS.navbarMenus]: ruNavbarMenus,
      [NS.profile]: ruProfile,
      [NS.adminPages]: ruAdminPages,
      [NS.jobPortal]: ruJobPortal,
      [NS.auth]: ruAuth,
      [NS.home]: ruHome,
      [NS.assessments]: ruAssessments,
    },
  },
  lng: defaultLocale,
  fallbackLng: 'en',
  defaultNS: NS.common,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
